import React, { memo, useState, useEffect } from "react";
import { LottieAnimation } from "@swiggy-private/core-ui";
import { LottieOverlayContainer, WhiteOverlay } from "../../CrossSellM2Carousel.style";

export interface MagicItemsLottieOverlayProps {
    showOverlay: boolean;
    isWidgetUnlocked: boolean;
    isLottieVisible: boolean;
    lottieUrl: string | undefined;
    onLottieComplete: () => void;
    onDOMLoaded: () => void;
    shouldPlayLottie: boolean;
}

const MagicItemsLottieOverlay = ({
    showOverlay,
    isWidgetUnlocked,
    isLottieVisible: _isLottieVisible,
    lottieUrl,
    onLottieComplete,
    onDOMLoaded,
    shouldPlayLottie,
}: MagicItemsLottieOverlayProps) => {
    void _isLottieVisible;

    const [forceHideWhiteMask, setForceHideWhiteMask] = useState(false);
    const [hasLottieCompleted, setHasLottieCompleted] = useState(false);
    const showWhiteMask = !hasLottieCompleted && !forceHideWhiteMask;
    useEffect(() => {
        if (shouldPlayLottie && showWhiteMask) {
            const timeout = setTimeout(() => {
                setForceHideWhiteMask(true);
            }, 500);

            return () => clearTimeout(timeout);
        }
    }, [shouldPlayLottie, showWhiteMask]);

    if (!showOverlay || !isWidgetUnlocked) {
        return null;
    }

    const handleLottieComplete = () => {
        setHasLottieCompleted(true);
        onLottieComplete();
    };

    return (
        <>
            {showWhiteMask && <WhiteOverlay data-testid="magic-items-white-overlay" />}
            {shouldPlayLottie && (
                <LottieOverlayContainer data-testid="magic-items-lottie-container">
                    {lottieUrl ? (
                        <LottieAnimation
                            fileName={lottieUrl}
                            visible={true}
                            playLottie={true}
                            autoplay={true}
                            loop={false}
                            backwardSpeed={1}
                            forwardSpeed={1}
                            playIfVisible={false}
                            onPlayComplete={handleLottieComplete}
                            onDOMLoaded={onDOMLoaded}
                            preserveAspect="none"
                            enableFrameEvent={false}
                        />
                    ) : null}
                </LottieOverlayContainer>
            )}
        </>
    );
};

export default memo(MagicItemsLottieOverlay);
